'use client';
import React from 'react';
import LouiseButton, { CtaTargetType } from '@/components/buttons/LouiseButton';
import ReactHtmlParser from 'react-html-parser';

type Content = {
  title: string;
  description?: string;
  cta: string;
  ctaTarget: 'register';
  locale: string;
};

const CTABanner = ({ title, description, cta, ctaTarget, locale }: Content) => {
  let target: string;
  switch (ctaTarget) {
    case 'register':
      target = 'register';
      break;
    default:
      target = 'register';
  }

  return (
    <section className="tw-mt-14 lg:tw-mt-14">
      <div className="tw-relative tw-z-10 tw-container tw-mx-auto tw-max-w-7xl">
        <div className="tw-text-center">
          <div className="tw-bg-gradient-to-r tw-from-blue-600 tw-to-purple-600 tw-rounded-2xl tw-p-8 sm:tw-p-12 tw-text-white">
            <h3 className="tw-text-2xl sm:tw-text-3xl tw-font-bold tw-mb-4 tw-font-['Lexend'] tw-text-white">
              {ReactHtmlParser(title)}
            </h3>
            <p className="tw-text-blue-100 tw-mb-8 tw-max-w-2xl tw-mx-auto tw-font-['Lexend']">{description}</p>
            <LouiseButton color="white" cta={cta} ctaTarget={target as CtaTargetType} locale={locale} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
